import axios from 'axios'

const V2_TOKEN = process.env.VUE_APP_HUGGY_V2_TOKEN
const isDev = process.env.NODE_ENV === 'development'
const N8N_PROXY = process.env.VUE_APP_N8N_HUGGY_PROXY

// Em dev: chama /v2/chats, /v2/agents direto (proxy do webpack)
// Em prod: chama N8N com ?path=chats, ?path=agents
const api = axios.create({
  baseURL: isDev ? '/v2' : N8N_PROXY
})

api.interceptors.request.use((config) => {
  if (isDev) {
    if (V2_TOKEN) {
      config.headers['X-Authorization'] = `Bearer ${V2_TOKEN}`
      config.headers['Content-Type'] = 'application/json'
      config.headers['Accept'] = 'application/json'
    }
  } else {
    // Em prod, converte o path pra query parameter pro N8N
    const endpoint = (config.url || '').replace(/^\//, '')
    config.url = ''
    config.params = { ...config.params, path: endpoint }
  }
  return config
})

// Helper
const unwrap = (response) => {
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response?.data?.data)) return response.data.data
  return response?.data ?? []
}

// Chats
export const getChats = async (params = {}) => {
  const response = await api.get('/chats', { params })
  return unwrap(response)
}

export const getAllChats = async (params = {}, { maxPages = 50 } = {}) => {
  const allChats = []
  for (let page = 0; page < maxPages; page++) {
    try {
      const response = await api.get('/chats', { params: { ...params, page } })
      const data = unwrap(response)
      const items = Array.isArray(data) ? data : []
      if (items.length === 0) break
      allChats.push(...items)
      if (items.length < 20) break
    } catch (e) {
      break
    }
  }
  return allChats
}

// Contacts
export const getContacts = async (params = {}) => {
  const response = await api.get('/contacts', { params })
  return unwrap(response)
}

// Agents
export const getAgents = async () => {
  const response = await api.get('/agents')
  return unwrap(response)
}

// Feedback
export const getChatFeedback = async (chatId) => {
  try {
    const response = await api.get(`/chats/${chatId}/feedback`)
    const data = response?.data
    // N8N proxy retorna array, API direto retorna objeto
    if (Array.isArray(data)) return data[0] ?? null
    return data ?? null
  } catch (e) {
    return null
  }
}

// Chat Messages
export const getChatMessages = async (chatId) => {
  const response = await api.get(`/chats/${chatId}/messages`)
  return unwrap(response)
}

export const isV2Available = () => !!V2_TOKEN
